<template>
  <v-app-bar app height="80">
    <v-container>
      <router-link 
        v-if="jeDealer"
        to="/" 
        style="position: absolute; left: 14px" 
        :style="isMobile ? { top: '15px' } : { top: '20px' }">
        <img
          class="mr-4"
          :srcset="require(`../assets/img/logo-tl${isMobile ? '-mobil' : ''}${$vuetify.theme.dark ? '-dark' : '-light'}.svg`)"
        />
      </router-link>
      <a
        style="position: absolute; left: 14px"
        :style="isMobile ? { top: '15px' } : { top: '20px' }"
        @click="setExternalUrl({ url: logoUrl })"
        v-else
      >
        <img
          class="mr-4"
          :srcset="require(`../assets/img/logo-tl${isMobile ? '-mobil' : ''}${$vuetify.theme.dark ? '-dark' : '-light'}.svg`)"
        />
      </a>
      <v-row>
        <v-col cols="6">
          <v-tabs v-if="jeDealer" hide-slider class="pa-0 app-header-nav" style="height: 80px">
            <v-tab to="/obchodne-pripady" class="text-none">Obchodné prípady</v-tab>
          </v-tabs>
          <h2 v-if="!jeDealer && !isMobile" class="pa-0 app-header-nav">Nové financovanie</h2>
        </v-col>
        <v-col cols="6">
          <div class="app-header-search" v-if="jeDealer">
            <v-text-field
              outlined
              placeholder="Vyhľadávať Nájomcu, Obchodný prípad alebo Zmluvu"
              append-icon="mdi-magnify"
              v-model="query"
              @keydown.enter="searchFullText"
              @input="val => setFullTextQuery(val)"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <div style="display: flex; position: absolute; right: 0px; top: 15px">
        <template v-if="jePrihlaseny">
          <template v-if="jeDealer">
            <v-btn class="mr-3 btn-primary" style="margin-top: 5px" to="/obchodny-pripad"
              >Nový prípad</v-btn
            >
            <v-menu transition="slide-x-transition" offset-y rounded="xl" class="">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon v-bind="attrs" v-on="on" class="mr-3 app-header-menu-button">
                  <v-icon class="app-header-menu-button" size="35">$avatar</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-list class="pa-0">
                  <v-list-item>
                    <v-list-item-title>{{ user.name }} ({{ user.login }})</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title> ID Operatora : {{ user.id }}</v-list-item-title>
                  </v-list-item>

                  <v-list-item to="/administracia" v-if="user.admin">
                    <v-list-item-title>Administrácia</v-list-item-title>
                  </v-list-item>
                  <v-list-item to="/zmena-hesla" v-if="user.frmLogged">
                    <v-list-item-title>Zmeniť heslo</v-list-item-title>
                  </v-list-item>
                  <v-list-item to="/zmena-hesla-signatus" v-if="user.branchNumber">
                    <v-list-item-title>Zmeniť Signatus heslo</v-list-item-title>
                  </v-list-item>
                  <v-list-item to="/logout" v-if="user.frmLogged">
                    <v-list-item-title>Odhlásiť</v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list flat>
                  <v-list-item-group v-model="settings" multiple active-class="">
                    <v-list-item @click="switchTheme()">
                      <v-list-item-action>
                        <v-checkbox
                          class="dynamic_check_box"
                          :input-value="this.$vuetify.theme.dark"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>Dark theme</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="envDebug" @click="setDebug(!debug)">
                      <v-list-item-action>
                        <v-checkbox class="dynamic_check_box" :input-value="debug"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>Debug mode</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-divider></v-divider>
                <span class="ml-10px mb-5px text--disabled">ver. {{ version }}</span>
              </v-card>
            </v-menu>
          </template>
          <template v-else>
            <v-btn
              v-if="!isMobile"
              class="btn-secondary"
              style="margin-top: 5px"
              @click="setExternalUrl({ url: clientZoneUrl })"
              >Klientská zóna</v-btn
            >
            <v-menu
              content-class="user-setting-menu"
              class="user-menu"
              v-model="showMenu"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="ml-3"
                  style="
                    display: flex;
                    align-self: center;
                    padding: 0px 13px 0px 21px !important;
                    width: 302px;
                  "
                >
                  <v-icon v-if="!isMobile" class="mr-3 app-header-menu-button" size="48">$avatar</v-icon>

                  <div v-if="!isMobile" style="display: grid">
                    <span class="f18 white100 text-overflow">{{ currentProfileName }}</span>
                    <span class="f14 gs100 text-overflow">{{ user.name }}</span>
                  </div>
                  <v-icon v-if="!isMobile" class="primary--text pl-12px" style="margin-left: auto">
                    mdi-chevron-down
                  </v-icon>
                  <template v-else>
                    <v-icon v-if="!showMenu" class="primary--text pt-13px pr-12px" style="margin-left: auto">
                      mdi-menu
                    </v-icon>
                    <v-btn v-else class="mobile-close-button" style="">
                      <v-icon style="color: white">
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </template>
                </div>
              </template>

              <v-card :style="!isMobile ? { width: '300px' } : null">
                <v-list class="pa-0">
                  <v-list-item class="menu-header" v-if="isMobile">
                    <v-btn
                      class="btn-secondary"
                      style="margin-top: 5px; width: 100%; height: 47px;"
                      @click="setExternalUrl({ url: clientZoneUrl })"
                      >Klientská zóna</v-btn
                    >
                  </v-list-item>
                  <v-list-item class="menu-header" @click="!isMobile && (showMenu = false)">
                    <v-list-item-title>
                      <div style="display: flex; align-self: center">
                        <v-icon class="mr-3 app-header-menu-button" size="48">$avatar</v-icon>

                        <div style="display: grid">
                          <span
                            class="f18 white100 text-overflow"
                            style="align-self: center; line-height: 1.5"
                            >{{ currentProfileName }}</span
                          >
                          <span
                            class="f14 gs100 text-overflow"
                            style="align-self: center; line-height: 1.5"
                            >{{ user.name }}</span
                          >
                        </div>
                        <v-icon v-if="!isMobile" class="primary--text pl-12px" style="margin-left: auto">
                          mdi-chevron-up</v-icon
                        >
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="setExternalUrl({ url: clientZoneProfileSettingsUrl })">
                    <v-list-item-action>
                      <v-icon>mdi-cog-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Nastavenia klientského profilu </v-list-item-title>
                  </v-list-item>
                  <template v-if="allProfiles.length > 1">
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-title class="f12"
                        >Prepnúť sa do iného klientskeho profilu</v-list-item-title
                      >
                    </v-list-item>
                    <template v-for="(item, index) in allProfiles">
                      <v-list-item
                        v-if="index < 3"
                        :key="index"
                        :class="{ 'active-item': item.idProfilu == user.profileId }"
                        @click="changeProfile(item)"
                      >
                        <v-list-item-action>
                          <v-icon>{{
                            item.idProfilu == user.profileId
                              ? 'mdi-radiobox-marked'
                              : 'mdi-radiobox-blank'
                          }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-title class="text-overflow">{{
                          item.nazov
                        }}</v-list-item-title>
                      </v-list-item>
                    </template>
                    <v-list-item @click="setExternalUrl({ url: clientZoneProfilesUrl })">
                      <v-list-item-action>
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-list-item-action>
                      <v-list-item-title style="display: flex">
                        <span style="align-self: center"
                          >Moje klientské profily ({{ allProfiles.length }})</span
                        >
                        <v-icon style="margin-left: auto"
                          >mdi-chevron-right
                        </v-icon></v-list-item-title
                      >
                    </v-list-item>
                  </template>
                  <v-list-item @click="getCreateProfileLink()">
                    <v-list-item-action>
                      <v-icon>mdi-plus</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Pridať nový profil</v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list flat>
                  <v-list-item-group v-model="settings" multiple active-class="">
                    <v-list-item @click="switchTheme()" class="switch-item">
                      <v-list-item-content>
                        <v-list-item-title
                          ><v-switch
                            :input-value="this.$vuetify.theme.dark"
                            inset
                            label="Tmavá téma"
                            hide-details
                          ></v-switch
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="envDebug" @click="setDebug(!debug)" class="switch-item">
                      <v-list-item-content>
                        <v-list-item-title
                          ><v-switch
                            :input-value="debug"
                            inset
                            label="Debug mode"
                            hide-details
                          ></v-switch
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item to="/logout" v-if="user.frmLogged" class="logout-item">
                      <v-list-item-action>
                        <v-icon>mdi-power</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Odhlásiť sa</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <template v-if="envDebug">
                  <v-divider></v-divider>
                  <span
                    class="ml-10px mb-5px text--disabled"
                    style="cursor: pointer"
                    @click="$router.push('/version')"
                    >Verzia</span
                  >
                </template>
                <!-- <v-divider></v-divider> -->
                <!-- <span class="ml-10px mb-5px text--disabled">ver. {{ version }}</span> -->
              </v-card>
            </v-menu>
          </template>
        </template>
        <template v-else>
          <v-btn class="mr-3 btn-secondary" style="margin-top: 5px; height: 32px !important" @click="loginFromAnonymous()"
            >Prihlásiť sa</v-btn
          >
        </template>
      </div>
    </v-container>
  </v-app-bar>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import protectedAxios from '../auth/axios';
import TextBox from './basic/TextBox.vue';
import { eventBus } from '../main.js';
import { store } from '../store';

export default {
  components: {
    TextBox,
  },
  watch: {
    fullTextQuery(val) {
      if (!val) this.query = null;
    },
  },
  computed: {
    ...mapGetters('auth', ['user', 'allProfiles', 'currentProfileName', 'loggedIn']),
    ...mapGetters(['fullTextQuery', 'debug', 'jeDealer', 'profile', 'jePrihlaseny','isMobile']),
  },
  data() {
    return {
      deleting: false,
      query: this.fullTextQuery,
      version: process.env.VUE_APP_VERSION,
      settings: [],
      envDebug: window._env_config.DEBUG,
      myProfile: this.profile,
      showMenu: false,
      logoUrl: '',
      clientZoneUrl: '',
      clientZoneProfilesUrl: '',
      clientZoneProfileSettingsUrl: '',
    };
  },
  methods: {
    ...mapMutations('auth', ['setProfile']),
    ...mapMutations(['setFullTextQuery', 'setDebug', 'setExternalUrl']),
    switchTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem('darkTheme', this.$vuetify.theme.dark);
    },
    deleteCache() {
      this.deleting = true;
      protectedAxios
        .post(`controls/resetcache`, null, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => (this.deleting = false));
    },
    searchFullText() {
      this.setFullTextQuery(this.query);
      if (this.$route.name !== 'obchodne-pripady') this.$router.push('/obchodne-pripady');

      eventBus.$emit('searchFullText');
    },
    changeProfile(_profile) {
      if (_profile.idProfilu != this.user.profileId)
        this.setExternalUrl({ url: '', data: _profile.idProfilu, from: 'changeProfile' });
    },
    async getCreateProfileLink() {
      await protectedAxios.get('/login/create-profile-link').then(res => {
        if (res.data.redirectUrl) {
          let query = '?ref=eklient';
          let obcNum = localStorage.getItem('curr_new_obc_num');
          let step = localStorage.getItem('curr_new_obc_step');

          if (obcNum) {
            query += '&obcNum=' + obcNum;
          }
          if (step) {
            query += '&step=' + step;
          }

          window.onbeforeunload = null;
          window.location.href = res.data.redirectUrl + query;
        }
      });
    },
    async loginFromAnonymous() {
      if (!this.loggedIn) {
        window.onbeforeunload = null;

        await store.dispatch('auth/authenticate', {
          customQueryParams: {
            ref: 'eklient',
            step: localStorage.getItem('curr_new_obc_step'),
            obcNum: localStorage.getItem('curr_new_obc_num'),
          },
        });
      }
    },
  },
  async mounted() {
    await protectedAxios
      .get(`login/logo-url-redirect`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(res => (this.logoUrl = res.data));

    await protectedAxios.get('login/client-zone-url').then(res => {
      this.clientZoneUrl = res.data.url;
      this.clientZoneProfilesUrl = res.data.url + '/moje-klientske-profily';
      this.clientZoneProfileSettingsUrl = res.data.url + '/udaje-o-firme';
    });
  },
  created() {
    this.$vuetify.theme.dark =
      JSON.parse(localStorage.getItem('darkTheme')) === false ? false : true;
  },
};
</script>

<style lang="scss"></style>
